import { TApiSet } from "../../api/endpoints/Set";
import {
  IFetchSetsCompletedAction,
  IFetchSetsFailedAction,
  IFetchSetsStartedAction,
  SETS_FETCH_COMPLETED,
  SETS_FETCH_FAILED,
  SETS_FETCH_STARTED
} from "../action-creators/sets";

export type TSetsState = {
  loading: boolean;
  loadedAt: null | number;
  error: null | Error;
  data: Array<TApiSet>
};

const initialSubState = () => ({
  loading: false,
  loadedAt: null,
  error: null,
  data: []
});

type TAllowedActions = IFetchSetsStartedAction | IFetchSetsCompletedAction | IFetchSetsFailedAction;

const setsReducer = (state: TSetsState = initialSubState(), action: TAllowedActions) => {
  switch (action.type) {
    case SETS_FETCH_STARTED:
      return {
        ...state,
        loading: true,
        error: null
      };

    case SETS_FETCH_COMPLETED:
      return {
        ...state,
        loadedAt: Date.now(),
        loading: false,
        error: null,
        data: action.data
      };

    case SETS_FETCH_FAILED:
      return {
        ...state,
        loadedAt: Date.now(),
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export default setsReducer;
